export default "__VITE_ASSET__YcI_87VH__"